export const ru = {
  'app.name': 'Слой',
  'language.label': 'Язык интерфейса',
  'language.ru': 'Русский',
  'language.en': 'English',
  'login.error': 'Не удалось войти. Попробуйте ещё раз.',
  'login.emailRequired': 'Сначала введите email.',
  'login.emailNotVerified': 'Сначала подтвердите адрес электронной почты — проверьте входящие или запросите письмо повторно.',
  'login.checkInbox': 'Проверьте входящие.',
  'login.resendError': 'Не удалось отправить письмо.',
  'login.resending': 'Отправляем…',
  'login.resend': 'Отправить письмо подтверждения снова',
  'login.enterCode': 'Ввести код из письма',
  'login.password': 'Пароль',
  'login.forgotPassword': 'Забыли пароль?',
  'login.passwordPlaceholder': 'Введите пароль',
  'login.submitting': 'Входим...',
  'login.submit': 'Войти',
  'auth.tabLogin': 'Вход',
  'auth.tabRegister': 'Регистрация',
  'auth.email': 'Почта',
  'auth.emailPlaceholder': 'you@example.ru',
  'password.show': 'Показать пароль',
  'password.hide': 'Скрыть пароль',
  'register.name': 'Имя',
  'register.namePlaceholder': 'Как вас зовут',
  'register.password': 'Пароль',
  'register.passwordPlaceholder': 'Минимум 8 символов',
  'register.submitting': 'Регистрируем...',
  'register.submit': 'Зарегистрироваться',
  'register.genericError': 'Не удалось создать аккаунт. Попробуйте ещё раз.',
  'register.legalPrefix': 'Заполняя форму, вы принимаете условия',
  'register.legalOfferLink': 'публичной оферты',
  'register.legalAnd': 'и даёте',
  'register.legalConsentLink': 'согласие',
  'register.legalConsentSuffix': 'на обработку персональных данных',
  'dashboard.projects': 'Проекты',
  'dashboard.allProjects': 'Все проекты',
  'dashboard.shared': 'Расшаренные',
  'dashboard.favorites': 'Избранные',
  'dashboard.support': 'Поддержка',
  'dashboard.noFavorites': 'Пока нет избранных',
  'dashboard.createProject': 'Создать проект',
  'dashboard.creatingProject': 'Создаём...',
  'dashboard.defaultProjectName': 'Проект {number}',
  'dashboard.emptyAllTitle': 'Проектов пока нет',
  'dashboard.emptyAllDescription': 'Создайте первый проект кнопкой «Создать проект» выше, чтобы начать работу с картой.',
  'dashboard.emptySharedTitle': 'Нет расшаренных проектов',
  'dashboard.emptySharedDescription': 'Когда коллеги пригласят вас в проект, он появится в этом разделе.',
  'project.roleEditor': 'Редактор',
  'project.roleViewer': 'Просмотр',
  'project.menu': 'Меню',
  'project.rename': 'Переименовать',
  'project.duplicate': 'Дублировать',
  'project.duplicating': 'Дублируем...',
  'project.copyName': '{name} (копия)',
  'project.duplicated': 'Создана копия «{name}»',
  'project.duplicateError': 'Не удалось дублировать проект',
  'project.delete': 'Удалить',
  'project.updated': 'Обновлён {date}',
  'project.removeFavorite': 'Убрать из избранного',
  'project.addFavorite': 'Добавить в избранное',
  'project.deleteTitle': 'Удалить проект?',
  'project.deleteDescription': 'Проект «{name}» и все его данные будут удалены безвозвратно.',
  'project.cancel': 'Отмена',
  'project.deleting': 'Удаление...',
  'project.renameTitle': 'Переименовать проект',
  'project.namePlaceholder': 'Название проекта',
  'project.saving': 'Сохранение...',
  'project.save': 'Сохранить',
  'profile.title': 'Профиль',
  'profile.avatarUpdated': 'Аватар обновлён',
  'profile.avatarError': 'Не удалось загрузить аватар',
  'profile.deleteAvatar': 'Удалить аватар',
  'profile.avatarDeleted': 'Аватар удалён',
  'profile.avatarDeleteError': 'Не удалось удалить аватар',
  'profile.uploading': 'Загрузка…',
  'profile.uploadPhoto': 'Загрузить фото',
  'profile.photoHint': 'До 2 МБ, JPEG, PNG, WebP или HEIC',
  'profile.name': 'Имя',
  'profile.editName': 'Изменить имя',
  'profile.cancel': 'Отмена',
  'profile.nameUpdated': 'Имя обновлено',
  'profile.nameError': 'Не удалось обновить имя',
  'profile.saving': 'Сохраняем…',
  'profile.save': 'Сохранить',
  'profile.security': 'Безопасность',
  'profile.changePassword': 'Смена пароля',
  'profile.currentPassword': 'Текущий пароль',
  'profile.newPassword': 'Новый пароль',
  'profile.repeatPassword': 'Повтор пароля',
  'profile.passwordMismatch': 'Пароли не совпадают',
  'profile.passwordChanged': 'Пароль изменён. Другие устройства будут выведены из системы.',
  'profile.passwordError': 'Не удалось изменить пароль. Проверьте текущий пароль.',
  'profile.savePassword': 'Сохранить пароль',
  'profile.emailConfirmTitle': 'Подтверждение нового email',
  'profile.currentEmail': 'Текущий email:',
  'profile.emailCodeHint': 'Введите 6-значный код из письма, отправленного на новый адрес',
  'profile.emailCode': 'Код из письма',
  'profile.checking': 'Проверяем…',
  'profile.confirm': 'Подтвердить',
  'profile.back': 'Назад',
  'profile.emailChangeTitle': 'Смена почты',
  'profile.emailChangeHint': 'Новый адрес для входа. Подтверждение придёт на новую почту.',
  'profile.newEmail': 'Новый email',
  'profile.requestEmailChange': 'Запросить смену почты',
  'profile.emailLinkSent': 'Ссылка отправлена. Проверьте почту и введите код.',
  'profile.emailRequestError': 'Не удалось запросить смену email. Проверьте пароль.',
  'profile.emailChanged': 'Email успешно изменён.',
  'profile.emailCodeError': 'Неверный или просроченный код.',
  'profile.plan': 'Тариф',
  'profile.planFree': 'Эксклюзивный',
  'profile.planDescription': 'Сейчас все функции бесплатны. В будущем появятся платные тарифы.',
  'profile.planUnlimitedAll': 'Безлимит на всё',
  'profile.statsSection': 'Статистика',
  'profile.statProjects': 'Проекты',
  'profile.statPoints': 'Точки',
  'profile.statPresentations': 'Презентации',
  'profile.statFiles': 'Объём файлов',
  'profile.statViews': 'Просмотры карт',
  'profile.statsEmpty': 'Пока пусто. Создайте первый проект — и здесь появится статистика.',
  'profile.legal': 'Уголок потребителя',
  'profile.legalDescription': 'Документы, которые мы обязаны разместить',
  'profile.legalOffer': 'Публичная оферта',
  'profile.legalPrivacyPolicy': 'Политика конфиденциальности',
  'profile.legalConsent': 'Согласие на обработку персональных данных',
  'profile.logout': 'Выйти из аккаунта',
  'admin.title': 'Админка',
  'admin.nav.overview': 'Обзор',
  'admin.nav.workspaces': 'Команды',
  'admin.nav.users': 'Пользователи',
  'admin.nav.projects': 'Проекты',
  'admin.stat.totalUsers': 'Всего пользователей',
  'admin.stat.verifiedUsers': 'Подтверждённых',
  'admin.stat.totalProjects': 'Всего проектов',
  'admin.stat.publicProjects': 'Публичных',
  'admin.stat.layers': 'Слоёв',
  'admin.stat.features': 'Объектов',
  'admin.stat.uploads': 'Загрузок',
  'admin.stat.comments': 'Комментариев',
  'admin.stat.presentations': 'Презентаций',
  'admin.stat.pmtiles': 'Размер тайлов',
  'admin.chart.usersGrowth': 'Регистрации (30 дней)',
  'admin.chart.projectsGrowth': 'Новые проекты (30 дней)',
  'admin.integrations.title': 'Интеграции по провайдерам',
  'admin.integrations.empty': 'Интеграций пока нет',
  'admin.users.searchPlaceholder': 'Поиск по email или имени',
  'admin.users.colEmail': 'Email',
  'admin.users.colName': 'Имя',
  'admin.users.colVerified': 'Подтверждён',
  'admin.users.colProjects': 'Проектов',
  'admin.users.colCreated': 'Регистрация',
  'admin.users.badgeAdmin': 'Админ',
  'admin.users.empty': 'Пользователи не найдены',
  'admin.projects.searchPlaceholder': 'Поиск по названию или email владельца',
  'admin.projects.colName': 'Проект',
  'admin.projects.colOwner': 'Владелец',
  'admin.projects.colVisibility': 'Доступ',
  'admin.projects.colLayers': 'Слоёв',
  'admin.projects.colFeatures': 'Объектов',
  'admin.projects.colSize': 'Размер',
  'admin.projects.colUpdated': 'Обновлён',
  'admin.projects.public': 'Публичный',
  'admin.projects.private': 'Приватный',
  'admin.projects.empty': 'Проекты не найдены',
  'admin.detail.storage': 'Хранилище',
  'admin.detail.dbBytes': 'Данные (БД)',
  'admin.detail.pmtilesBytes': 'Тайлы (pmtiles)',
  'admin.detail.s3Bytes': 'Файлы (S3)',
  'admin.detail.totalBytes': 'Всего',
  'admin.detail.layers': 'Слои',
  'admin.detail.owner': 'Владелец',
  'admin.detail.projectsOwned': 'Проекты',
  'admin.detail.created': 'Создан',
  'admin.detail.loadingS3': 'Считаем размер файлов…',
  'admin.common.loadError': 'Не удалось загрузить данные',
  'admin.common.prev': 'Назад',
  'admin.common.next': 'Вперёд',
  'admin.common.pageInfo': '{from}–{to} из {total}',
  'admin.sort.label': 'Сортировка',
  'admin.sort.newest': 'Сначала новые',
  'admin.sort.oldest': 'Сначала старые',
  'admin.sort.email': 'По email',
  'admin.sort.projects': 'По проектам',
  'admin.sort.name': 'По названию',
  'admin.stat.workspaces': 'Команд',
  'admin.stat.billableUsers': 'Платных участников',
  'admin.workspaces.searchPlaceholder': 'Поиск по названию, адресу или email владельца',
  'admin.workspaces.colName': 'Команда',
  'admin.workspaces.colOwner': 'Владелец',
  'admin.workspaces.colMembers': 'Платных / всего',
  'admin.workspaces.colProjects': 'Карт',
  'admin.workspaces.colStorage': 'Место',
  'admin.workspaces.colViews': 'Просмотров за месяц',
  'admin.workspaces.colCreated': 'Создана',
  'admin.workspaces.planHint': 'Тариф команды',
  'admin.workspaces.empty': 'Команды не найдены',
  'admin.sort.members': 'По участникам',
  'admin.sort.billable': 'По платным',
  'admin.sort.views': 'По просмотрам',
  'admin.sort.size': 'По размеру',
  'admin.moderation.suspended': 'Заморожена',
  'admin.moderation.suspend': 'Заморозить',
  'admin.moderation.unsuspend': 'Разморозить',
  'admin.moderation.reasonLabel': 'Причина',
  'admin.moderation.reasonPlaceholder': 'Что именно нарушено и по чьей жалобе',
  'admin.moderation.reasonHint': 'Причину увидит владелец. Она же останется в журнале как мотивировка решения.',
  'admin.moderation.confirmTitleWorkspace': 'Заморозить команду',
  'admin.moderation.confirmTitleProject': 'Заморозить карту',
  'admin.moderation.confirmBodyWorkspace': 'Публичные карты команды перестанут открываться, поддомен отдаст заглушку. Данные останутся на месте, владелец сохранит доступ к редактору.',
  'admin.moderation.confirmBodyProject': 'Карта перестанет открываться публично: страница, встройка, презентация и тайлы. Данные останутся на месте, владелец сохранит доступ к редактору.',
  'admin.moderation.suspendedBy': 'Заморозил',
  'admin.moderation.suspendedAt': 'Заморожена',
  'admin.moderation.cancel': 'Отмена',
  'admin.moderation.failed': 'Не удалось изменить статус',
  'workspace.switcher.label': 'Выбрать воркспейс',
  'workspace.switcher.fallback': 'Воркспейс',
  'workspace.switcher.groupTitle': 'Воркспейсы',
  'workspace.switcher.create': 'Создать воркспейс',
  'workspace.switcher.settings': 'Настройки воркспейса',
} as const;

export type TranslationKey = keyof typeof ru;

export const en = {
  'app.name': 'Sloy',
  'language.label': 'Interface language',
  'language.ru': 'Русский',
  'language.en': 'English',
  'login.error': 'Could not sign in. Please try again.',
  'login.emailRequired': 'Enter your email first.',
  'login.emailNotVerified': 'Verify your email first — check your inbox or request another verification email.',
  'login.checkInbox': 'Check your inbox.',
  'login.resendError': 'Could not send the email.',
  'login.resending': 'Sending…',
  'login.resend': 'Resend verification email',
  'login.enterCode': 'Enter the code from the email',
  'login.password': 'Password',
  'login.forgotPassword': 'Forgot password?',
  'login.passwordPlaceholder': 'Enter your password',
  'login.submitting': 'Signing in...',
  'login.submit': 'Sign in',
  'auth.tabLogin': 'Sign in',
  'auth.tabRegister': 'Sign up',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'you@example.com',
  'password.show': 'Show password',
  'password.hide': 'Hide password',
  'register.name': 'Name',
  'register.namePlaceholder': 'Your name',
  'register.password': 'Password',
  'register.passwordPlaceholder': 'At least 8 characters',
  'register.submitting': 'Signing up...',
  'register.submit': 'Sign up',
  'register.genericError': 'Could not create the account. Please try again.',
  'register.legalPrefix': 'By clicking “Sign up”, you accept the',
  'register.legalOfferLink': 'Terms of Service',
  'register.legalAnd': 'and',
  'register.legalConsentLink': 'consent',
  'register.legalConsentSuffix': 'to the processing of your personal data',
  'dashboard.projects': 'Projects',
  'dashboard.allProjects': 'All projects',
  'dashboard.shared': 'Shared with me',
  'dashboard.favorites': 'Favorites',
  'dashboard.support': 'Support',
  'dashboard.noFavorites': 'No favorites yet',
  'dashboard.createProject': 'Create project',
  'dashboard.creatingProject': 'Creating...',
  'dashboard.defaultProjectName': 'Project {number}',
  'dashboard.emptyAllTitle': 'No projects yet',
  'dashboard.emptyAllDescription': 'Create your first project with the “Create project” button above to start working on a map.',
  'dashboard.emptySharedTitle': 'No shared projects',
  'dashboard.emptySharedDescription': 'Projects your teammates invite you to will appear here.',
  'project.roleEditor': 'Editor',
  'project.roleViewer': 'Viewer',
  'project.menu': 'Menu',
  'project.rename': 'Rename',
  'project.duplicate': 'Duplicate',
  'project.duplicating': 'Duplicating...',
  'project.copyName': '{name} (copy)',
  'project.duplicated': '“{name}” copy created',
  'project.duplicateError': 'Could not duplicate the project',
  'project.delete': 'Delete',
  'project.updated': 'Updated {date}',
  'project.removeFavorite': 'Remove from favorites',
  'project.addFavorite': 'Add to favorites',
  'project.deleteTitle': 'Delete project?',
  'project.deleteDescription': '“{name}” and all its data will be permanently deleted.',
  'project.cancel': 'Cancel',
  'project.deleting': 'Deleting...',
  'project.renameTitle': 'Rename project',
  'project.namePlaceholder': 'Project name',
  'project.saving': 'Saving...',
  'project.save': 'Save',
  'profile.title': 'Profile',
  'profile.avatarUpdated': 'Profile picture updated',
  'profile.avatarError': 'Could not upload the profile picture',
  'profile.deleteAvatar': 'Remove photo',
  'profile.avatarDeleted': 'Profile picture removed',
  'profile.avatarDeleteError': 'Could not remove the profile picture',
  'profile.uploading': 'Uploading…',
  'profile.uploadPhoto': 'Upload photo',
  'profile.photoHint': 'Up to 2 MB, JPEG, PNG, WebP, or HEIC',
  'profile.name': 'Name',
  'profile.editName': 'Edit name',
  'profile.cancel': 'Cancel',
  'profile.nameUpdated': 'Name updated',
  'profile.nameError': 'Could not update the name',
  'profile.saving': 'Saving…',
  'profile.save': 'Save',
  'profile.security': 'Security',
  'profile.changePassword': 'Change password',
  'profile.currentPassword': 'Current password',
  'profile.newPassword': 'New password',
  'profile.repeatPassword': 'Repeat password',
  'profile.passwordMismatch': 'Passwords do not match',
  'profile.passwordChanged': 'Password changed. Other devices have been signed out.',
  'profile.passwordError': 'Could not change the password. Check your current password.',
  'profile.savePassword': 'Save password',
  'profile.emailConfirmTitle': 'Confirm new email',
  'profile.currentEmail': 'Current email:',
  'profile.emailCodeHint': 'Enter the 6-digit code sent to your new email address',
  'profile.emailCode': 'Email code',
  'profile.checking': 'Checking…',
  'profile.confirm': 'Confirm',
  'profile.back': 'Back',
  'profile.emailChangeTitle': 'Change email',
  'profile.emailChangeHint': 'Use a new address to sign in. A confirmation email will be sent there.',
  'profile.newEmail': 'New email',
  'profile.requestEmailChange': 'Request email change',
  'profile.emailLinkSent': 'Link sent. Check your inbox and enter the code.',
  'profile.emailRequestError': 'Could not request an email change. Check your password.',
  'profile.emailChanged': 'Email changed successfully.',
  'profile.emailCodeError': 'The code is invalid or has expired.',
  'profile.plan': 'Plan',
  'profile.planFree': 'Exclusive',
  'profile.planDescription': 'All features are currently free. Paid plans will be introduced in the future.',
  'profile.planUnlimitedAll': 'Unlimited everything',
  'profile.statsSection': 'Statistics',
  'profile.statProjects': 'Projects',
  'profile.statPoints': 'Points',
  'profile.statPresentations': 'Presentations',
  'profile.statFiles': 'Files size',
  'profile.statViews': 'Map views',
  'profile.statsEmpty': 'Nothing yet. Create your first project and stats will show up here.',
  'profile.legal': 'Consumer corner',
  'profile.legalDescription': 'Documents and legal information about the service',
  'profile.legalOffer': 'Public offer',
  'profile.legalPrivacyPolicy': 'Privacy policy',
  'profile.legalConsent': 'Personal data processing consent',
  'profile.logout': 'Sign out',
  'admin.title': 'Admin',
  'admin.nav.overview': 'Overview',
  'admin.nav.workspaces': 'Workspaces',
  'admin.nav.users': 'Users',
  'admin.nav.projects': 'Projects',
  'admin.stat.totalUsers': 'Total users',
  'admin.stat.verifiedUsers': 'Verified',
  'admin.stat.totalProjects': 'Total projects',
  'admin.stat.publicProjects': 'Public',
  'admin.stat.layers': 'Layers',
  'admin.stat.features': 'Features',
  'admin.stat.uploads': 'Uploads',
  'admin.stat.comments': 'Comments',
  'admin.stat.presentations': 'Presentations',
  'admin.stat.pmtiles': 'Tiles size',
  'admin.chart.usersGrowth': 'Sign-ups (30 days)',
  'admin.chart.projectsGrowth': 'New projects (30 days)',
  'admin.integrations.title': 'Integrations by provider',
  'admin.integrations.empty': 'No integrations yet',
  'admin.users.searchPlaceholder': 'Search by email or name',
  'admin.users.colEmail': 'Email',
  'admin.users.colName': 'Name',
  'admin.users.colVerified': 'Verified',
  'admin.users.colProjects': 'Projects',
  'admin.users.colCreated': 'Registered',
  'admin.users.badgeAdmin': 'Admin',
  'admin.users.empty': 'No users found',
  'admin.projects.searchPlaceholder': 'Search by name or owner email',
  'admin.projects.colName': 'Project',
  'admin.projects.colOwner': 'Owner',
  'admin.projects.colVisibility': 'Visibility',
  'admin.projects.colLayers': 'Layers',
  'admin.projects.colFeatures': 'Features',
  'admin.projects.colSize': 'Size',
  'admin.projects.colUpdated': 'Updated',
  'admin.projects.public': 'Public',
  'admin.projects.private': 'Private',
  'admin.projects.empty': 'No projects found',
  'admin.detail.storage': 'Storage',
  'admin.detail.dbBytes': 'Data (DB)',
  'admin.detail.pmtilesBytes': 'Tiles (pmtiles)',
  'admin.detail.s3Bytes': 'Files (S3)',
  'admin.detail.totalBytes': 'Total',
  'admin.detail.layers': 'Layers',
  'admin.detail.owner': 'Owner',
  'admin.detail.projectsOwned': 'Projects',
  'admin.detail.created': 'Created',
  'admin.detail.loadingS3': 'Calculating file size…',
  'admin.common.loadError': 'Failed to load data',
  'admin.common.prev': 'Prev',
  'admin.common.next': 'Next',
  'admin.common.pageInfo': '{from}–{to} of {total}',
  'admin.sort.label': 'Sort',
  'admin.sort.newest': 'Newest',
  'admin.sort.oldest': 'Oldest',
  'admin.sort.email': 'By email',
  'admin.sort.projects': 'By projects',
  'admin.sort.name': 'By name',
  'admin.stat.workspaces': 'Workspaces',
  'admin.stat.billableUsers': 'Billable members',
  'admin.workspaces.searchPlaceholder': 'Search by name, address or owner email',
  'admin.workspaces.colName': 'Workspace',
  'admin.workspaces.colOwner': 'Owner',
  'admin.workspaces.colMembers': 'Billable / total',
  'admin.workspaces.colProjects': 'Maps',
  'admin.workspaces.colStorage': 'Storage',
  'admin.workspaces.colViews': 'Views this month',
  'admin.workspaces.colCreated': 'Created',
  'admin.workspaces.planHint': 'Workspace plan',
  'admin.workspaces.empty': 'No workspaces found',
  'admin.sort.members': 'By members',
  'admin.sort.billable': 'By billable',
  'admin.sort.views': 'By views',
  'admin.sort.size': 'By size',
  'admin.moderation.suspended': 'Suspended',
  'admin.moderation.suspend': 'Suspend',
  'admin.moderation.unsuspend': 'Unsuspend',
  'admin.moderation.reasonLabel': 'Reason',
  'admin.moderation.reasonPlaceholder': 'What was violated and who reported it',
  'admin.moderation.reasonHint': 'The owner will see this reason. It is also kept as the statement of reasons.',
  'admin.moderation.confirmTitleWorkspace': 'Suspend workspace',
  'admin.moderation.confirmTitleProject': 'Suspend map',
  'admin.moderation.confirmBodyWorkspace': 'Public maps of this workspace stop opening and the subdomain serves a stub. Data stays intact and the owner keeps editor access.',
  'admin.moderation.confirmBodyProject': 'The map stops being served publicly: page, embed, presentation and tiles. Data stays intact and the owner keeps editor access.',
  'admin.moderation.suspendedBy': 'Suspended by',
  'admin.moderation.suspendedAt': 'Suspended',
  'admin.moderation.cancel': 'Cancel',
  'admin.moderation.failed': 'Could not change the status',
  'workspace.switcher.label': 'Select workspace',
  'workspace.switcher.fallback': 'Workspace',
  'workspace.switcher.groupTitle': 'Workspaces',
  'workspace.switcher.create': 'Create workspace',
  'workspace.switcher.settings': 'Workspace settings',
} satisfies Record<TranslationKey, string>;

export const translations = { ru, en } as const;

export type Language = keyof typeof translations;
